import React, { Fragment } from 'react'
import { copyToClipboard } from 'functions/copy/copyToClipboard'
import { ProvSeedPair } from '../interfaces'
import { Title } from '../ProvFairStyled'

export default function ProvablySeedPair({
  pf,
  colors,
  handleNotification,
}: ProvSeedPair) {
  return (
    <Fragment>
      {pf.map((item: any, id: any) => (
        <Title key={id} copyCursor={item.enableCopy} colors={colors}>
          <h4>{item.Title}</h4>
          <textarea
            onClick={e =>
              item.enableCopy && copyToClipboard(e, handleNotification)
            }
            value={item.Content}
            spellCheck='false'
            readOnly
            className={item.Title === 'Nonce' ? 'nonce' : ''}
          />
        </Title>
      ))}
    </Fragment>
  )
}
